/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Simulation } from "./Simulation";
import {
  SimulationFromJSON,
  SimulationFromJSONTyped,
  SimulationToJSON,
  SimulationToJSONTyped,
} from "./Simulation";

/**
 *
 * @export
 * @interface PaginatedSimulationList
 */
export interface PaginatedSimulationList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<Simulation>;
}

/**
 * Check if a given object implements the PaginatedSimulationList interface.
 */
export function instanceOfPaginatedSimulationList(value: object): value is PaginatedSimulationList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedSimulationListFromJSON(json: any): PaginatedSimulationList {
  return PaginatedSimulationListFromJSONTyped(json, false);
}

export function PaginatedSimulationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedSimulationList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(SimulationFromJSON),
  };
}

export function PaginatedSimulationListToJSON(json: any): PaginatedSimulationList {
  return PaginatedSimulationListToJSONTyped(json, false);
}

export function PaginatedSimulationListToJSONTyped(
  value?: PaginatedSimulationList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(SimulationToJSON),
  };
}
